import { isEqual } from 'lodash'
import ReactJson from 'react-json-view'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle
} from '@/components/ui/sheet'

type JSONEditorProps = {
  onUpdate?: (data: unknown) => Promise<void>
  isUpdating?: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  open: boolean
  originalData: unknown
  dataState: unknown
  setDataState: React.Dispatch<React.SetStateAction<unknown>>
}

export const JSONEditor = ({
  onUpdate,
  dataState,
  open,
  originalData,
  setDataState,
  setOpen,
  isUpdating = false
}: JSONEditorProps) => (
  <Sheet onOpenChange={(o) => setOpen(o)} open={open}>
    <SheetContent className="flex flex-col">
      <SheetHeader>
        <SheetTitle className="pb-1 text-primary border-b border-border">
          {(originalData as any)?.name}
        </SheetTitle>
      </SheetHeader>
      <div className="rounded-md mx-2 p-2 overflow-y-auto relative">
        <ReactJson
          displayDataTypes
          displayObjectSize
          enableClipboard
          iconStyle="square"
          {...(onUpdate && {
            onAdd: (e) => setDataState(e.updated_src),
            onDelete: (e) => {
              if (e.name === 'id') return false
              setDataState(e.updated_src)
            },
            onEdit: (e) => {
              if (e.name === 'id') return false
              setDataState(e.updated_src)
            }
          })}
          src={originalData || {}}
          style={{
            padding: '1rem',
            background: 'rgb(45 65 99)',
            borderRadius: 8
          }}
          theme={'solarized'}
          validationMessage="Editing ID is not allowed."
        />
      </div>
      {onUpdate && (
        <SheetFooter>
          <Button
            disabled={isEqual(originalData, dataState)}
            loading={isUpdating}
            onClick={() => onUpdate(dataState)}
          >
            Save changes
          </Button>
        </SheetFooter>
      )}
    </SheetContent>
  </Sheet>
)
